import { createFileRoute, redirect } from '@tanstack/react-router'

// The landing page was renamed from Welcome to Insights. Sends old links, bookmarks and notification emails,
// with their search and hash, to the same page under the new path.
export const Route = createFileRoute('/_auth/_modules/crt/welcome/$')({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: location.href.replace('/crt/welcome', '/crt/insights'),
      replace: true,
    })
  },
})
